(function () {
    'use strict';

    /*
     * Copyright (c) 2017 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .service('CampaignPrescriptionsService', CampaignPrescriptionsService);

    CampaignPrescriptionsService.$inject = ['_'];

    function CampaignPrescriptionsService (_) {
        var isEditMode = false;
        var editId;

        var service = {
            isEdit: isEdit,
            edit: edit,
            cancel: cancel,
            getEditId: getEditId
        };

        return service;

        function getEditId () {
            return editId;
        }

        function isEdit () {
            return isEditMode;
        }

        function edit (id) {
            editId = id;
            isEditMode = true;
        }

        function cancel () {
            isEditMode = false;
            editId = null;
        }
    }
})();

